import { defineModule } from '@/app/router/defineModule.ts';

export default defineModule({
    name: 'changelog',
    routes: [
        {
            path: '/changelog',
            name: 'changelog',
            component: () => import('#modules/changelog/pages/index.vue'),
            meta: {
                layout: 'public',
            },
        },
    ],
});
